"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
let EditSessionDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.sessionData = null;
    this.sessionName = "";
    this.appToken = "";
  }
  open(row, token) {
    return __async(this, null, function* () {
      try {
        this.sessionData = row;
        this.appToken = token;
        this.sessionName = row.name;
        this._edit_session_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this._edit_session_dialog.hide();
    this.sessionData = null;
    this.sessionName = "";
    this.appToken = "";
  }
  handleSave() {
    return __async(this, null, function* () {
      try {
        yield API.put(`https://gateway.kuajingvs.com/chat/v1/chat-sessions/${this.sessionData.id}`, {
          name: this.sessionName
        }, {
          headers: {
            "Authorization": this.appToken
          }
        });
        this.$message.success(this.$t("edit_session_dialog.save_success"));
        this.$emit("refreshsessionlist");
        this.close();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("edit-session-dialog")
], EditSessionDialog.prototype, "_edit_session_dialog", 2);
__decorateClass([
  Debounce(800)
], EditSessionDialog.prototype, "handleSave", 1);
EditSessionDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], EditSessionDialog);
export {
  EditSessionDialog as default
};
